// LocationContext.js
import React from "react";

const LocationContext = React.createContext();

export default LocationContext;
